/**
 * Runtime invariant assertion for algorithmic code.
 * Throws with a descriptive message if the condition is false.
 * Use this to make implicit assumptions explicit and loud at violation sites.
 *
 * @example
 * invariant(nodes[0].kind === 'source', 'DAG node 0 must be source');
 * invariant(R.length === nodes.length, `R.length (${R.length}) must equal nodes.length (${nodes.length})`);
 */
export function invariant(condition: boolean, message: string): asserts condition {
    if (!condition) {
        throw new Error(`Invariant violated: ${message}`);
    }
}
